const audiences = [
  {
    icon: 'ri-restaurant-2-line',
    title: '餐飲空間',
    desc: '咖啡廳、餐廳、複合式餐飲品牌、飲品店',
    img: 'https://readdy.ai/api/search-image?query=modern%20upscale%20restaurant%20interior%20design%20warm%20lighting%20wood%20texture%20stone%20wall%20elegant%20dining%20space%20commercial%20design%20minimalist%20neutral%20tones&width=600&height=400&seq=aud001&orientation=landscape',
  },
  {
    icon: 'ri-store-2-line',
    title: '零售門市',
    desc: '品牌旗艦店、精品選物、連鎖門市、展售空間',
    img: 'https://readdy.ai/api/search-image?query=high-end%20retail%20store%20interior%20design%20fashion%20boutique%20minimalist%20white%20walls%20elegant%20display%20shelving%20commercial%20space%20clean%20modern&width=600&height=400&seq=aud002&orientation=landscape',
  },
  {
    icon: 'ri-building-4-line',
    title: '辦公空間',
    desc: '品牌總部、共享辦公、創意工作室、企業辦公室',
    img: 'https://readdy.ai/api/search-image?query=modern%20corporate%20office%20interior%20design%20open%20workspace%20natural%20light%20wood%20flooring%20clean%20minimalist%20professional%20atmosphere%20neutral%20warm%20tones&width=600&height=400&seq=aud003&orientation=landscape',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: '診所醫美',
    desc: '診所、醫美中心、健康養生品牌、SPA空間',
    img: 'https://readdy.ai/api/search-image?query=upscale%20medical%20aesthetic%20clinic%20interior%20design%20clean%20white%20marble%20texture%20soft%20lighting%20luxury%20wellness%20space%20modern%20minimal&width=600&height=400&seq=aud004&orientation=landscape',
  },
  {
    icon: 'ri-vip-crown-2-line',
    title: '接待會所',
    desc: '品牌接待中心、會員俱樂部、高端商務空間',
    img: 'https://readdy.ai/api/search-image?query=luxurious%20VIP%20reception%20lounge%20interior%20design%20high-end%20hospitality%20space%20rich%20materials%20dark%20wood%20marble%20elegant%20lighting%20exclusive%20atmosphere&width=600&height=400&seq=aud005&orientation=landscape',
  },
  {
    icon: 'ri-layout-masonry-line',
    title: '展示空間',
    desc: '品牌展廳、展覽空間、商品展示中心、快閃店',
    img: 'https://readdy.ai/api/search-image?query=contemporary%20brand%20showroom%20exhibition%20space%20interior%20design%20open%20gallery%20style%20sophisticated%20display%20area%20neutral%20background%20architectural%20lighting&width=600&height=400&seq=aud006&orientation=landscape',
  },
];

export default function AudienceSection() {
  return (
    <section className="py-24 md:py-32 bg-[#fafaf8]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-[#b8956a] text-sm font-medium tracking-[0.2em] uppercase mb-4">Who We Serve</p>
          <h2
            className="font-bold text-[#1a1a1a] leading-[1.35] mb-5"
            style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)' }}
          >
            我們服務的商業空間類型
          </h2>
          <p className="text-[#5a5a5a] max-w-xl mx-auto" style={{ fontSize: '1.1875rem' }}>
            無論是開店裝修、老店翻新，還是品牌空間升級，
            我們專注服務各類商業型空間客戶。
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {audiences.map((a, i) => (
            <div
              key={i}
              className="group relative overflow-hidden rounded-2xl cursor-pointer"
            >
              <div className="w-full h-[280px] md:h-[320px]">
                <img
                  src={a.img}
                  alt={a.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-8 h-8 flex items-center justify-center bg-[#b8956a]/80 rounded-lg">
                    <i className={`${a.icon} text-white text-sm`}></i>
                  </div>
                  <h3 className="text-white font-semibold" style={{ fontSize: '1.1875rem' }}>{a.title}</h3>
                </div>
                <p className="text-white/70 text-sm">{a.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
